import {user} from '../../api/access'
import {serv} from '@/api/config'
import LauncherAPI from '@/api/launcher'
import {RemoteAPI} from '@/api'
import {history} from '@/api/analystic'
import AppState from '@/plugins/appstate'
import Logger from '@/plugins/logger'

// ============================================================================
// Windows launcher 호출 (RC·FT 공통)
// ============================================================================
// 2-경로: ① document.title에 캡션을 박아 설치된 launcher가 창 제목을 읽어 접속 파라미터를
//   가져가게 하고(레거시 채널) + URL scheme 발사로 launcher 직접 실행.
//   ② launcher 미설치 대비로 설치 파일을 무조건 다운로드.
// 설치 여부를 브라우저에서 신뢰성 있게 감지할 방법이 없어(크롬 프로토콜 대화상자가 focus/타이밍을
// 흔듦) 감지 휴리스틱·JWT 방식을 걷어내고 "제목 채널 + 무조건 다운로드" 옛 방식으로 롤백.

// 숨겨진 <a> click으로 URL scheme 트리거.
// window.location 직접 대입은 미등록 프로토콜일 때 about:blank로 갈 수 있어 <a> 방식 사용.
function triggerScheme(url) {
  const a = document.createElement('a')
  a.href = url
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * Windows에서 launcher 호출 (RC·FT 공통 진입점).
 *   1) document.title에 캡션 세팅 → 설치된 launcher가 창 제목을 읽어 접속 파라미터 획득
 *   2) 설치 파일을 무조건 다운로드 (미설치 대비)
 *   3) URL scheme 발사 → 설치된 launcher 직접 실행 (param에도 캡션 전달)
 * 모두 클릭 gesture 안에서 동기 실행 (비동기 없음 — 팝업 차단·gesture 소실 방지).
 *
 * @param action 'RC'(원격접속) | 'FT'(파일전송)
 * @param dev 대상 Device (dev_os_id, guid 사용)
 * @param usr 현재 user() 결과 (token, company_fk 사용)
 * @returns openModal 토스트 키 suffix ('launch' → i18n: remote.<name>.launch)
 */
function launchWindows(action, dev, usr) {
  // serverNum: 2017-04-01 이후 경과 초 (LinkMeMine 내부 식별 번호)
  const serverNum = Math.floor((new Date().getTime() - new Date('2017-04-01').getTime()) / 1000)

  // 캡션 — 설치된 launcher가 창 제목·scheme param 양쪽에서 받던 레거시 형식
  const caption = [
    process.env.VUE_APP_BROWSER_TITLE_PREFIX,   // 'LMMSE_CONTROL'
    action,
    usr.token,
    dev.dev_os_id + dev.guid,
    usr.company_fk,
    dev.dev_os_id,
    serverNum,
    ''
  ].join('-')

  // ① 설치된 launcher가 읽어갈 창 제목 채널
  document.title = caption

  // ② 무조건 다운로드 (미설치 대비) — 설치 사용자는 exe도 받지만 무해
  window.open(`${serv.download}/ManualLauncher.exe?cache=${new Date().getTime()}`, '_blank')

  // ③ scheme 발사 — 설치된 launcher 직접 실행
  triggerScheme(`${process.env.VUE_APP_URL_SCHEME}://param=${caption}`)

  return 'launch'
}

const execActiveX = (version, options) => {
  let args = ['AP2P']
  switch (options.command) {
    case 'RC':
      if (options.devId.indexOf('oldverion') == 0) {
        args = ['-c']
        args.push(options.kmsAddr)
        args.push(options.kmsPort)
        args.push('0')
        args.push('6')
        args.push(options.devId)
        args.push(options.n2nAddr)
        args.push(options.n2nPort)
        args.push(options.cSharpAddr)
        args.push(options.cSharpPort)
      } else {
        args.push(options.command)
        args.push(options.kmsAddr)
        args.push(options.kmsPort)
        args.push(options.devId)
        args.push(options.userId)
        args.push('TRUE')
        args.push('1')
        args.push(options.rcAuth)
        args.push(options.ftAuth)
        args.push(options.inputLock)
        args.push(options.adminAuth)
        args.push(options.userName.replace(/\s+/g, '&amp;nbsp;'))
        args.push(options.token)
        args.push(options.companyKey)
        args.push(options.n2nAddr)
        args.push(options.n2nPort)
        args.push(options.cSharpAddr)
        args.push(options.cSharpPort)
        args.push(options.deviceName.replace(/\s+/g, '&amp;nbsp;'))
        args.push(options.osType)
      }
      break
    case 'FT':
      args.push(options.command)
      args.push(options.kmsAddr)
      args.push(options.kmsPort)
      args.push(options.devId)
      args.push(options.userId)
      args.push(options.token)
      args.push(options.companyKey)
      args.push(options.n2nAddr)
      args.push(options.n2nPort)
      args.push(options.cSharpAddr)
      args.push(options.cSharpPort)
      args.push(options.deviceName.replace(/\s+/g, '&amp;nbsp;'))
      args.push(options.osType)
      break
  }

  let params;
  if (options.devId.indexOf('oldverion') == 0) {
    params = {
      body: `
      <OBJECT classid="CLSID:A5261EF0-76F0-4D9C-891C-56813163D9DA" codebase="${AppState.Path.download}/loader/KoinoLoader.cab#version=2017,4,27,0" width="271" height="14" id="KoinoLoader">
      <param name = "CompanyName" value = "LinkMeMine">
      <param name = "ApplicationName" value = "LMMViewer">
      <param name = "SectionName" value = "ManualLauncher">
      <param name = "Version" value = "${version}">
      <param name = "ExecuteFileName" value = "LMMViewer2K.exe ${args.join(' ')}">
      <param name = "HostAddress" value = "${AppState.Path.domain}">
      <param name = "HostURL" value = "download/lmmviewer/">
      </OBJECT>
      `
    }
  } else {
    params = {
      body: `
      <OBJECT classid="CLSID:A5261EF0-76F0-4D9C-891C-56813163D9DA" codebase="${AppState.Path.download}/loader/KoinoLoader.cab#version=2017,4,27,0" width="271" height="14" id="KoinoLoader">
      <param name = "CompanyName" value = "LinkMeMine">
      <param name = "ApplicationName" value = "LMMViewer">
      <param name = "SectionName" value = "ManualLauncher">
      <param name = "Version" value = "${version}">
      <param name = "ExecuteFileName" value = "LMMViewer.exe ${args.join(' ')}">
      <param name = "HostAddress" value = "${AppState.Path.domain}">
      <param name = "HostURL" value = "download/lmmviewer/">
      </OBJECT>
      `
    }
  }
  AppState.$emit('show-hidden-dialog', params)
}

const remote = (dev, noActiveX) => {
  const {ua} = AppState
  const usr = user()

  history.post('audit', {
    act_name_id: 1,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  if (!noActiveX && !process.env.VUE_APP_USE_ACTIVEX) noActiveX = true

  // IE고 대상 OS가 모바일이 아닐때 ActiveX 실행
  if (!noActiveX && ua.browser.name === 'IE' && dev.dev_os_id !== 4 && dev.dev_os_id !== 5) {
    LauncherAPI(dev.dev_os_id + dev.guid, (err, {session, version}) => {
      if (err) {
        Logger.error(err)
        return 'activex_error'
      }
      execActiveX(version, {
        command: 'RC',
        kmsAddr: session.kms_addr,
        kmsPort: session.kms_port,
        devId: dev.guid,
        userId: usr.mgrid,
        rcAuth: session.rc_auth,
        ftAuth: session.ft_auth,
        inputLock: session.input_lock,
        adminAuth: session.admin_auth,
        userName: session.user_name,
        token: usr.token,
        companyKey: usr.company_fk,
        n2nAddr: session.n2nserver,
        n2nPort: session.n2nport,
        cSharpAddr: session.csharp_api_addr,
        cSharpPort: session.csharp_api_port,
        deviceName: session.device_name.replace(/\s/g, '_'),
        osType: dev.dev_os_id
      })
    })
    return 'activex'
  } else if (ua.os.name === 'Windows') {
    return launchWindows('RC', dev, usr)
  //} else if (ua.os.name === 'Mac OS' && window.navigator.maxTouchPoints > 0 && AppState.isApplication) {
  } else if (ua.os.name === 'Mac OS' && window.navigator.maxTouchPoints > 0) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      usr.mgrid,
      dev.dev_os_id,
      ''
    ].join(':')
    try {
      window.webkit.messageHandlers.observe.postMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'application'
  } else if (ua.os.name === 'Mac OS') {
    let w = 480, h = 180
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var systemZoom = width / window.screen.availWidth;
    var left = (width - w) / 2 / systemZoom + dualScreenLeft
    var top = (height - h) / 2 / systemZoom + dualScreenTop

    let params = 
      '?device_pk=' + dev.pk +
      '&token=' + usr.token +
      '&company_fk=' + usr.company_fk +
      '&device_guid=' + dev.guid +
      '&mgr_id=' + usr.mgrid +
      '&os_id=' + dev.dev_os_id +
      '&device_id=' + dev.alias +
      '&user_name=' + usr.name +
      '&kms_addr=' + dev.kms_addr +
      '&kms_port=' + dev.kms_port

    let b64 = btoa(encodeURIComponent(`LinkMeMineViewer://${params}`))
    let nw = window.open(`/static/mac_launcher.html?d=${b64}`, 'maclauncher', `width=${w / systemZoom},height=${h / systemZoom},top=${top},left=${left}`)
    if (window.focus) nw.focus()
    return 'urlscheme'
  } else if (ua.os.name === 'iOS' && AppState.isApplication) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      usr.mgrid,
      dev.dev_os_id,
      ''
    ].join(':')
    try {
      window.webkit.messageHandlers.observe.postMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'mobile'
  // } else if (ua.os.name === 'Android' && AppState.isApplication) {
  } else if (/Android/i.test(window.navigator.userAgent) && AppState.isApplication) {
    let connection = [
      'RC',
      dev.kms_addr,
      dev.kms_port,
      dev.pk,
      usr.token,
      usr.company_fk,
      dev.guid,
      // 안드로이드 파라미터 갯수 문제로 #으로 분기
      usr.mgrid + '#' + dev.dev_os_id,
      usr.name,
      ''
    ].join(':')
    try {
      window.AndroidViewerApp.setMessage(connection)
    } catch (err) {
      Logger.error(err)
      return 'error'
    }
    return 'mobile'
  } else return false
}

const transfer = dev => {
  const {ua} = AppState
  const usr = user()

  history.post('audit', {
    act_name_id: 2,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  if (ua.browser.name === 'IE') {
    LauncherAPI(dev.dev_os_id + dev.guid, (err, {session, version}) => {
      if (err) {
        Logger.error(err)
        return 'activex_error'
      }
      execActiveX(version, {
        command: 'FT',
        kmsAddr: session.kms_addr,
        kmsPort: session.kms_port,
        devId: dev.guid,
        userId: usr.mgrid,
        token: usr.token,
        companyKey: usr.company_fk,
        n2nAddr: session.n2nserver,
        n2nPort: session.n2nport,
        cSharpAddr: session.csharp_api_addr,
        cSharpPort: session.csharp_api_port,
        deviceName: session.device_name.replace(/\s/g, '_'),
        osType: dev.dev_os_id
      })
    })
    return 'activex'
  } else if (ua.os.name === 'Windows') {
    return launchWindows('FT', dev, usr)
  } else if (ua.os.name === 'Mac OS') {
    return false
  } else if (ua.os.name === 'iOS' && AppState.isApplication) {
    return false
  } else if (ua.os.name === 'Android' && AppState.isApplication) {
    return false
  } else return false
}

// AuditHistory.save(argument, function(data){
//     if(data.status==200){
//         $scope.audit_result = data.objects;
//     }
// });

const shutdown = dev => {
  const usr = user()
  var params = {
    device_pk: dev.pk,
    member_pk: usr.pk,
    act_name_id: 4,
    act_type_id: 1,
    old_value: 1,
    new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'shutdown'
  }

  history.post('audit', {
    act_name_id: 4,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const reboot = dev => {
  const usr = user()
  var params = {
    device_pk: dev.pk,
    member_pk: usr.pk,
    act_name_id: 3,
    act_type_id: 1,
    old_value: 1,
    new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'reboot'
  }

  history.post('audit', {
    act_name_id: 3,
    act_type_id: 1,
    device_pk: dev.pk,
    member_pk: usr.pk,
    new_value: 1,
    old_value: 1
  })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const restart = dev => {
  // const usr = user()
  var params = {
    // device_pk: dev.pk,
    // member_pk: usr.pk,
    // act_name_id: 3,
    // act_type_id: 1,
    // old_value: 1,
    // new_value: 1,
    // 실행시 추가 audit에는 제외
    type: 'agent_restart'
  }

  // 원격기기 재시작에 대한 아이디 필요
  // history.post('audit', {
  //   act_name_id: 3,
  //   act_type_id: 1,
  //   device_pk: dev.pk,
  //   member_pk: usr.pk,
  //   new_value: 1,
  //   old_value: 1
  // })

  RemoteAPI.put(dev.guid, params)
  return 'requested'
}

const remove = (dev, requestType) => {
  var params = {
    type: requestType || 'delete'
  }

  return RemoteAPI.put(dev.guid, params)
}

export default { remote, transfer, reboot, shutdown, restart, remove }